<!--加入低碳-->

<template>
  <div>
    <!--logo-->
    <div class='logo'>
      <img src='../../assets/images/logo.png'>
    </div>
    <template>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="首页" name="homePage">
          <div class='content'>
            <h2>焦点分析</h2>
            <div v-for='item in tableListData' :key='item.id'  class='hotContent'>
              <!--市场分析-->
              <div class='contentBox'>
                <div class='img' >
                  <el-image
                    v-if='item.imageUrl != null'
                    :src='item.imageUrl'
                    :fit='fit'></el-image>
                </div>
                <h2>{{ item.title }} </h2>
                <p>
                  {{ item.content }} </p>
              </div>
              <el-row>
                <el-button class='small_but' size=' small' type='success'>详情咨询</el-button>
              </el-row>
            </div>
            <!--碳排放管理师报名与考试咨询系统-->
            <h2>碳排放管理师报名与考试咨询系统</h2>
            <div class='system'>
              <ul>
                <li class='consultationContent'>
                  <div class='frame'>
                    <img src='../../assets/images/trainingCente/signUp.png'>
                    <h3>报名条件</h3>
                    <el-button class='cssButton' size='mini' type='success' @click='consult(1)'>详情咨询</el-button>
                  </div>
                </li>
                <li class='consultationContent'>
                  <div class='frame'>
                    <img src='../../assets/images/trainingCente/time.png'>
                    <h3>报考时间</h3>
                    <el-button class='cssButton' size='mini' type='success' @click='consult(2)'>详情咨询</el-button>
                  </div>
                </li>
                <li class='consultationContent'>
                  <div class='frame'>
                    <img src='../../assets/images/trainingCente/cost.png'>
                    <h3>学习费用</h3>
                    <el-button class='cssButton' size='mini' type='success' @click='consult(3)'>详情咨询</el-button>
                  </div>
                </li>
                <li class='consultationContent'>
                  <div class='frame'>
                    <img src='../../assets/images/trainingCente/subject.png'>
                    <h3>学习科目</h3>
                    <el-button class='cssButton' size='mini' type='success' @click='consult(1)'>详情咨询</el-button>
                  </div>
                </li>
                <li class='consultationContent'>
                  <div class='frame'>
                    <img src='../../assets/images/trainingCente/work.png'>
                    <h3>就业前景</h3>
                    <el-button class='cssButton' size='mini' type='success' @click='consult(2)'>详情咨询</el-button>
                  </div>
                </li>
                <li class='consultationContent'>
                  <div class='frame'>
                    <img src='../../assets/images/trainingCente/direction.png'>
                    <h3>就业方向</h3>
                    <el-button class='cssButton' size='mini' type='success' @click='consult(3)'>详情咨询</el-button>
                  </div>
                </li>
              </ul>
            </div>

            <!-- 新增/编辑弹窗 -->
            <el-dialog :title='title' :visible.sync='open' :destroy-on-close='true' :modal='false' center>
              <el-form :model='productCategoryFrom' ref='productCategoryFrom' :rules='productCategoryRule' class='popUp'>
                <el-form-item label='姓  名:' prop='userName' label-width='65px'>
                  <el-input placeholder='姓  名' v-model='productCategoryFrom.userName' style='width: 264px;' clearable>
                  </el-input>
                </el-form-item>
                <el-form-item label=' 学  历:' prop='parentId' label-width='65px'>
                  <el-select v-model='value' placeholder='请选择学历'>
                    <el-option
                      v-for='item in options'
                      :key='item.value'
                      :label='item.label'
                      :value='item.value'>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label='手机号' prop='phone' label-width='65px'>
                  <el-input placeholder='手机号码:' v-model='productCategoryFrom.phone' style='width: 264px;' clearable>
                  </el-input>
                </el-form-item>
                <el-form-item label='请选择您想要咨询的问题' prop='phone'>
                </el-form-item>
                <div class='consultingService'>
                  <el-form-item>
                    <el-checkbox v-model='productCategoryFrom.checked1'>报名条件</el-checkbox>
                  </el-form-item>
                  <el-form-item>
                    <el-checkbox v-model='productCategoryFrom.checked2'>报考时间</el-checkbox>
                  </el-form-item>
                  <el-form-item>
                    <el-checkbox v-model='productCategoryFrom.checked3'>学习费用</el-checkbox>
                  </el-form-item>
                  <el-form-item>
                    <el-checkbox v-model='productCategoryFrom.checked4'>学习科目</el-checkbox>
                  </el-form-item>
                  <el-form-item>
                    <el-checkbox v-model='productCategoryFrom.checked5'>就业前景</el-checkbox>
                  </el-form-item>
                  <el-form-item>
                    <el-checkbox v-model='productCategoryFrom.checked6'>就业方向</el-checkbox>
                  </el-form-item>
                  <el-form-item>
                    <el-checkbox v-model='productCategoryFrom.checked7'>学习方式</el-checkbox>
                  </el-form-item>
                  <el-form-item>
                    <el-checkbox v-model='productCategoryFrom.checked8'>考试方式</el-checkbox>
                  </el-form-item>
                </div>
              </el-form>
              <div slot='footer' class='dialogFooter'>
                <el-button type='primary' @click='submitForm()'>确 定</el-button>

                <el-button @click='cancel()'>取 消</el-button>
              </div>
              <div>
                提交后会有老师联系您，为你提供咨询服务电话咨询:{{ this.tableData.contacts }} {{ this.tableData.contactNumber }}
              </div>
            </el-dialog>
          </div>
        </el-tab-pane>
        <el-tab-pane label="主营业务" name="mainBusiness">
        </el-tab-pane>
        <el-tab-pane label="经典案例" name="case"></el-tab-pane>
        <el-tab-pane label="新闻与资讯" name="newsCenter"></el-tab-pane>
        <el-tab-pane label="研究院" name="researchInstitute"></el-tab-pane>
        <el-tab-pane label="关于埃文" name="avi">
        </el-tab-pane>
      </el-tabs>
      <!--底部占位-->
      <div style='height: 80px;'>
      </div>
    </template>
    <!--底部选项卡-->
    <div class='bottom'>
      <ul>
        <li class='tab' @click="tabButton(1)">联系方式</li>
        <li class='tab' @click="tabButton(2)">加入低碳行业</li>
        <li class='tab' @click="tabButton(3)">合作网站</li>
      </ul>
      <p>企业节能减排与低碳发展综合解决方案提供商</p>
    </div>
  </div>
</template>
<script>
import { addExaminationStatistics, selectCarouselPicture, selectConfig, selectWebHotspotAnalysis } from '../../api/auth'

export default {
  created () {
    this.selectWebHotspotAnalysis()
    this.selectCarouselPicture()
    this.webConfig()
  },
  components: {
  },
  data () {
    return {
      activeName: 'homePage',
      input: '',
      problemTitle: '欢迎咨询！',
      problemOpen: true,
      isDialog: true,
      fit: 'fill', // 想要什么属性就在这个位置设置什么属性
      value: '',
      url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
      carouselList: [],
      queryParams: {},
      carouselParams: {
        type: 10
      },
      tableData: {
        contacts: '',
        contactNumber: ''
      },
      tableListData: [],
      // 是否显示弹出层
      open: false,
      ruleForm: {
        name: '',
        typeName: '',
        region: '',
        type: '',
        typeId: ''
      },
      options: [{
        value: '1',
        label: '其他'
      }, {
        value: '2',
        label: '中专'
      }, {
        value: '3',
        label: '大专'
      }, {
        value: '4',
        label: '本科'
      }, {
        value: '5',
        label: '硕士'
      }],
      // 类别表单
      productCategoryFrom: {
        id: null,
        parentId: 0,
        userName: '',
        code: null,
        content: '',
        title: '',
        profile: '',
        phone: '',
        checked1: false,
        checked2: false,
        checked3: false,
        checked4: false,
        checked5: false,
        checked6: false,
        checked7: false,
        checked8: false,
        author: '',
        imageUrl: '',
        isDisplay: '',
        releaseTime: null,
        educationType: '',
        type: '',
        image: [],
        showIndex: 0
      },
      // 表单校验
      productCategoryRule: {
        name: [
          { required: true, message: '姓名不能为空', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '手机不能为空', trigger: 'blur' }
        ]
      },
      title: '碳排放管理师报名与考试咨询系统',
      src: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg'
    }
  },
  methods: {
    tabButton (raw) {
      if (raw === 1) {
        // 联系方式
        this.$router.push({
          path: '/mobileContacInformation',
          query: {}
        })
      } else if (raw === 2) {
        // 加入低碳
        this.$router.push({
          path: '/moblielowCarbonIndustry',
          query: {}
        })
      } else if (raw === 3) {
        // 合作伙伴
        this.$router.push({
          path: '/mobileCooperativePartner',
          query: {}
        })
      }
    },
    handleClick (tab, event) {
      if (tab.name === 'homePage') {
        this.$router.push({
          path: '/mobileIndex',
          query: {
          }
        })
      } else if (tab.name === 'mainBusiness') {
        this.$router.push({
          path: '/mobileMainBusiness',
          query: {
          }
        })
      } else if (tab.name === 'case') {
        this.$router.push({
          path: '/mobileCase',
          query: {
          }
        })
      } else if (tab.name === 'researchInstitute') {
        this.$router.push({
          path: '/mobileResearchInstituter',
          query: {
          }
        })
      } else if (tab.name === 'avi') {
        this.$router.push({
          path: '/mobileAboutAvi',
          query: {
          }
        })
      } else if (tab.name === 'newsCenter') {
        this.$router.push({
          path: '/mobileNewsCenter',
          query: {
          }
        })
      }
    },

    clostDialog () {
      alert('关闭')
    },
    /** 查询网站配置 */
    webConfig () {
      let that = this
      selectConfig(this.queryParams).then(res => {
        that.tableData.contacts = res.contacts
        that.tableData.contactNumber = res.contactNumber
      })
    },
    jump (raw) {
    },
    /** 热点分析 */
    selectWebHotspotAnalysis () {
      let that = this
      selectWebHotspotAnalysis(this.queryParams).then(res => {
        res.forEach((value, index) => {
          value.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.imageUrl)
        })
        that.tableListData = res
      })
    },
    /** 滚动图  */
    selectCarouselPicture () {
      let that = this
      selectCarouselPicture(this.carouselParams).then(res => {
        res.forEach((value, index) => {
          value.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.imageUrl)
        })
        that.carouselList = res
      })
    },
    consult (type) {
      this.open = true
      this.title = '碳排放管理师报名与考试咨询系统'
    },
    /** 提交按钮 */
    submitForm: function () {
      let that = this

      this.$refs['productCategoryFrom'].validate(valid => {
        if (valid) {
          this.productCategoryFrom.content = this.content
          this.productCategoryFrom.educationType = this.value

          addExaminationStatistics(JSON.stringify(that.productCategoryFrom)).then(response => {
            if (response.code === '200') {
              that.msgSuccess('提交成功')
            } else {
              that.$message.error('保存失败')
            }
            that.open = false
            that.getList()
          })
          that.open = false
          // that.reset()
        }
      })
    },
    /** 清空弹窗数据 */
    cancel () {
      this.open = false
    }
  }
}
</script>

<style lang='less' scoped>
.content {
  width: 90%;
  margin: 20px auto;

  h2 {
    color: #000;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    margin: 10px 0;
  }

  //内容框样式
  .contentBox {
    border: 3px solid #90bc4f;
    width: 90%;
    margin: 0 auto;

    .img {
      width: 220px;
      height: 160px;
      margin: 20px auto 12px;
    }

    p {
      color: #333;
      font-size: 14px;
      padding: 0 20px 20px;
      line-height: 18px;
    }
  }

  //中按钮
  .small_but {
    display: block;
    background-color: #90bc4f;
    width: 120px;
    height: 36px;
    line-height: 10px;
    font-size: 16px;
    margin: 20px auto;
  }

  //碳排放管理师报名与考试咨询系统
  .system {
    height: 240px;
    margin-bottom: 20px;

    li {
      width: 50%;
      display: block;
      float: left;
      padding: 10px 10px;

      .frame {
        width: 100%;
        margin: 0 auto;
        border: 2px solid #90bc4f;
        border-radius: 15px;

        img {
          display: block;
          margin: 16px auto 0;
        }

        h3 {
          color: #000;
          font-size: 16px;
          font-weight: bold;
          text-align: center;
          margin: 10px 0;
        }

        .cssButton {
          display: block;
          background-color: #90bc4f;
          width: 80px;
          height: 28px;
          line-height: 10px;
          font-size: 14px;
          margin: 10px auto 20px;
        }
      }
    }
  }
}

//弹窗
::v-deep .el-dialog {
  position: absolute;
  top: 0%;
  right: 7%;
  width: 86%;
  border: 1px solid #90bc4f;

  .el-dialog__header {
    background-color: #90bc4f;

    .el-dialog__title {
      color: #fff;
    }
  }

  .el-input__inner {
    width: 230px;
  }

  //咨询问题
  .consultingService {
    .el-form-item {
      width: 50%;
      margin: 0;
      float: left;

      .el-form-item__content {
        .el-checkbox {
          height: 35px;
          float: left;
        }
      }
    }
  }
}

//确认、取消按钮
.dialogFooter {
}

.questionContent {
  background-color: #e1f3d8;
  min-height: 250px;
  border-radius: 8px;
  padding: 8px;
}

.inputContent {
  background-color: #fff;
  min-height: 50px;
  margin-top: 10px;
  border-radius: 5px;
  padding: 8px;
}

::v-deep .el-dialog__body {
  padding: 0 10px;
}

.but {
  margin: 10px 0px 15px 222px;
}
::v-deep .popUp{
  margin-top: 20px;
}
.el-row {
  &:last-child {
    margin-bottom: 0;
  }
}

//logo
.logo{
  img{
    width: 70%;
    display: block;
    margin:10px auto;
  }
}

//tabs样式
::v-deep .el-tabs__item {
  border: 1px solid #fff;
  background-color: #90bc4f;
  width: 33.33%;
  font-size: 14px;
  color: #fff;
  height: 40px;
  line-height: 40px;
  float: left;
  display: block;
  text-align: center;
}
::v-deep .el-tabs__item.is-top:nth-child(2) {
  padding-left: 20px;
}
::v-deep .el-tabs__item.is-top:nth-child(7) {
  padding-left: 0px;
}
//底部选项卡
.bottom{
  background-color: #fff;
  height: 80px;
  width: 100%;
  position: fixed;
  bottom: 0;
  .tab{
    width: 33.33%;
    float: left;
    text-align: center;
    background-color: #90bc4f;
    border: 1px solid #fff;
    font-size: 14px;
    color: #fff;
    height: 40px;
    line-height: 40px;
  }
  p{
    font-size: 14px;
    text-align: center;
    height: 40px;
    line-height: 40px;
    color:#90bc4f;
  }
}
::v-deep .el-tab-pane{
  height:620px;
}
//去掉tab下划线
::v-deep .el-tabs__active-bar {
  width: 0px !important;
}
</style>
